import React from "react";
import { ClinicContext } from "contexts";

type TitleBarProps = {
  name: string;
  disableBackButton?: boolean;
  onClickBackButton: (() => void) | null;
  centerTitle?: boolean;
  showLogo?: boolean;
};

const TitleBar: React.FC<TitleBarProps> = ({
  name,
  onClickBackButton,
  disableBackButton = false,
  centerTitle = false,
  showLogo = true,
}) => {
  const clinic = React.useContext(ClinicContext);

  return (
    <div style={styles.container}>
      <button
        disabled={disableBackButton || !onClickBackButton}
        style={{
          ...styles.backButton,
          cursor: !onClickBackButton
            ? "default"
            : disableBackButton
              ? "not-allowed"
              : "pointer",
          opacity: !onClickBackButton ? 0 : disableBackButton ? 0.5 : 1,
        }}
        onClick={(e) => {
          e.preventDefault();
          if (onClickBackButton) onClickBackButton();
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 6L9 12L15 18"
            stroke="#282B33"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {showLogo && (
          <img
            onClick={() => {
              const currentUrl = window.location.search;
              const urlSearchParams = new URLSearchParams(currentUrl);
              const urlClinicSdkKey = urlSearchParams.get("clinicSdkKey");
              if (urlClinicSdkKey === "49db9c88-42c9-4001-ada5-c2a875167c9b") {
                window.open("https://riccioplasticsurgery.com/", "_blank");
              }
              if (urlClinicSdkKey === "79ce9cc0-c031-4db1-84d4-6428df731928") {
                window.open("https://www.77plasticsurgery.com/", "_blank");
              }
              if (urlClinicSdkKey === "1af39432-b448-4ed1-bf79-cde94b9fb267") {
                window.open("https://drdanielbienstock.com/", "_blank");
              }
              if (urlClinicSdkKey === "7ab39072-ec75-4752-b8bf-dedd05fbdaf5") {
                window.open("https://yourdreambody.com/", "_blank");
              }
              if (urlClinicSdkKey === "fd2714a4-e831-4751-9ba8-27bb3c8b14a5") {
                window.open("https://milkandhoneybody.com/", "_blank");
              }

              window.open("https://clinicos.ai", "_blank");
            }}
            src={
              clinic?.logo_url ??
              "https://clinic-os.com/user-app-assets%2Fclinicos-text.png"
            }
            alt="clinic logo"
            style={styles.logo}
          />
        )}
        {name && (
          <div
            style={{
              ...styles.titleContainer,
              margin: centerTitle ? "0 auto" : "initial",
            }}
          >
            <p style={styles.title}>{name}</p>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: 0,
    position: "relative",
  },
  backButton: {
    position: "absolute",
    left: -10,
    top: 5,
    backgroundColor: "transparent",
    border: "none",
    marginRight: "auto",
    width: 60,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    marginTop: 5,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    color: "#282B33",
  },
  logo: {
    width: "100%",
    height: 65,
    cursor: "pointer",
    objectFit: "contain",
    margin: "0 auto",
  },
} as const;

export default TitleBar;
